// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_angular_animations_fesm2022_browser_mjs":"b20ab31f8fe9926b","src_app_stock-management_stock-management_routes_ts":"f5ded4b908c2703c"}[chunkId] + ".js";
};